import { cn } from "@util/helpers";

type ImagePlacehodlerProps = {
  /** This is the aspect ratio of the placeholder. */
  aspectRatio?:
    | "aspect-3x2"
    | "aspect-16x9"
    | "aspect-video"
    | "aspect-square"
    | (string & Record<never, never>);
  /** Optional additional styling for the placeholder */
  className?: string;
};

/** This is the placeholder image to be used in playwright. */
const ImagePlacehodler = ({
  aspectRatio = "aspect-3x2",
  className,
}: ImagePlacehodlerProps): React.ReactElement => {
  const isVideo = aspectRatio === "aspect-video";
  const minusAspect = aspectRatio.replaceAll("aspect-", "");
  const label = isVideo ? "16x9" : minusAspect;

  return (
    <div
      className={cn(
        "flex w-full items-center justify-center self-start bg-gray-500 text-xl font-bold text-white",
        aspectRatio,
        className
      )}
      data-testid="image-placeholder-component"
    >
      {label}
    </div>
  );
};

export default ImagePlacehodler;
